import { Routes } from '@angular/router';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { dashBoardGuard } from './Guards/dash-board.guard';
import { authGuardGuard } from './Guards/auth-guard.guard';
import { devToolsEntryGuard } from './Guards/devtools-entry.guard';
import { UnsubmailComponent } from './pages/unsubmail/unsubmail.component';
// import { LotteryTicketsComponent } from './pages/lottery-tickets/lottery-tickets.component';
// import { LotteryMainComponent } from './pages/lottery/lottery-main/lottery-main.component';
export const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    canActivate: [authGuardGuard],
  },
  {
    path: 'ForgotPassword',
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'reset-pass',
    loadComponent: () =>
      import('./forgot-change-password/forgot-change-password.component').then(
        (m) => m.ForgotChangePasswordComponent,
      ),
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./pages/new-password/new-password.component').then(
        (m) => m.NewPasswordComponent,
      ),
  },
  {
    path: 'SignUp',
    loadComponent: () =>
      import('./pages/signup/signup.component').then((m) => m.SignupComponent),
    data: { preload: true },
  },
  {
    path: 'VerifyEmail',
    loadComponent: () =>
      import('./pages/verification-email/verification-email.component').then(
        (m) => m.VerificationEmailComponent,
      ),
  },
  {
    path: 'Help',
    loadComponent: () =>
      import('./pages/landing-page/terms-and-conditions/terms-and-conditions.component').then(
        (m) => m.TermsAndConditionsComponent,
      ),
  },
  {
    path: 'check',
    loadComponent: () =>
      import('./pages/verify-payment/verify-payment.component').then(
        (m) => m.VerifyPaymentComponent,
      ),
  },
  {
    path: 'checkpay',
    loadComponent: () =>
      import('./pages/verifypaymentstripe/verifypaymentstripe.component').then(
        (m) => m.VerifypaymentstripeComponent,
      ),
  },
   {
    path: 'checkunsub',
    component: UnsubmailComponent,
  },
  {
    path: 'Terms&Condition',
    loadComponent: () =>
      import('./pages/landing-page/terms-and-conditions/terms-and-conditions.component').then(
        (m) => m.TermsAndConditionsComponent,
      ),
  },

  // { path: 'Refund&Cancellation', component: RefundComponent },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [dashBoardGuard, authGuardGuard],
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'spinner',
        loadComponent: () =>
          import('./components/spinner/spinner.component').then(
            (m) => m.SpinnerComponent,
          ),
      },
      // { path: 'spinner', component: SpinnerNewComponent },
      // { path: 'spinner', component: SpinnerNewDesignComponent },
      {
        path: 'account',
        loadComponent: () =>
          import('./pages/account/account.component').then(
            (m) => m.AccountComponent,
          ),
      },
      {
        path: 'wallet',
        loadComponent: () =>
          import('./pages/wallet/wallet.component').then(
            (m) => m.WalletComponent,
          ),
      },
      {
        path: 'redeem',
        loadComponent: () =>
          import('./pages/redeem/redeem.component').then(
            (m) => m.RedeemComponent,
          ),
      },
      {
        path: 'credentials',
        loadComponent: () =>
          import('./components/credentials/credentials.component').then(
            (m) => m.CredentialsComponent,
          ),
      },
      {
        path: 'changePass',
        loadComponent: () =>
          import('./pages/change-password/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent,
          ),
      },
      {
        path: 'ranks',
        loadComponent: () =>
          import('./components/ranks-screen/ranks-screen.component').then(
            (m) => m.RanksScreenComponent,
          ),
      },
      // { path: 'referrals', component: ReferralsScreenComponent },
      {
        path: 'referallist',
        loadComponent: () =>
          import('./pages/view-referal/view-referal.component').then(
            (m) => m.ViewReferalComponent,
          ),
      },
      {
        path: 'Terms&Conditions',
        loadComponent: () =>
          import('./pages/landing-page/terms-and-conditions/terms-and-conditions.component').then(
            (m) => m.TermsAndConditionsComponent,
          ),
      },
      {
        path: 'GuideLines',
        loadComponent: () =>
          import('./pages/GuideLines/Guidelines.component').then(
            (m) => m.Guidelines,
          ),
      },
      {
        path: 'edit-profile',
        loadComponent: () =>
          import('./pages/edit-userprofile/edit-userprofile.component').then(
            (m) => m.EditUserprofileComponent,
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/profile/profile.component').then(
            (m) => m.ProfileComponent,
          ),
      },
      {
        path: 'complaints',
        loadComponent: () =>
          import('./pages/complaints/complaints.component').then(
            (m) => m.ComplaintsComponent,
          ),
      },
      {
        path: 'complaints/:id',
        loadComponent: () =>
          import(
            './pages/complaints/complaint-detail/complaint-detail.component'
          ).then((m) => m.ComplaintDetailComponent),
      },
      {
        path: 'help-support',
        loadComponent: () =>
          import('./pages/landing-page/terms-and-conditions/terms-and-conditions.component').then(
            (m) => m.TermsAndConditionsComponent,
          ),
      },
      {
        path: 'lottery',
        loadComponent: () =>
          import('./pages/Lottery-Module/lottery-list/lottery-list.component').then(
            (m) => m.LotteryListComponent,
          ),
      },
      {
        path: 'lottery-number',
        loadComponent: () =>
          import('./pages/Lottery-Module/lottery-numbers/lottery-numbers.component').then(
            (m) => m.LotteryNumbersComponent,
          ),
      },
      {
        path: 'scratch',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('./dashboard/Sectrech Cards/sectrech-card-list/sectrech-card-list.component').then(
            (m) => m.SectrechCardListComponent,
          ),
      },
      {
        path: 'KYCform',
        loadComponent: () =>
          import('./pages/landing-page/kyc-form/kyc-form.component').then(
            (m) => m.kycformComponent,
          ),
      },
      {
        path: 'user-profile',
        loadComponent: () =>
          import('./pages/landing-page/user-profile/user-profile.component').then(
            (m) => m.UserProfileComponent,
          ),
      },
      {
        path: 'player-level',
        loadComponent: () =>
          import('./pages/player-level/player-level.component').then(
            (m) => m.PlayerLevelComponent,
          ),
      },

      {
        path: 'treasure-pick',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/TreasurePick/treasurepick.component').then(
            (m) => m.TreasurepickComponent,
          ),
      },
      // Old engine-wired Stack Builder - kept in games/component/stack-builder, route commented out
      // in favour of the new stackbuilder game below.
      // {
      //   path: 'StackBuilder',
      //   canActivate: [devToolsEntryGuard],
      //   loadComponent: () =>
      //     import('../app/games/component/stack-builder/stack-builder.component').then(
      //       (m) => m.StackBuilderComponent,
      //     ),
      // },
      {
        path: 'stack-builder',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/stackbuilder/stackbuilder.component').then(
            (m) => m.AppComponent,
          ),
      },
      // Old game URLs (before the games were renamed) - kept so bookmarks and shared links still open the game.
      { path: 'royalmatch', redirectTo: 'ace-win', pathMatch: 'full' },
      { path: 'BottleShooter', redirectTo: 'lucky-trigger', pathMatch: 'full' },
      { path: 'DiceRoll', redirectTo: 'sum-dice', pathMatch: 'full' },
      { path: 'bufalo-slot', redirectTo: 'cashbull', pathMatch: 'full' },
      { path: 'SectrechCards', redirectTo: 'scratch', pathMatch: 'full' },
      { path: 'TreasurePick', redirectTo: 'treasure-pick', pathMatch: 'full' },
      { path: 'stackbuilder', redirectTo: 'stack-builder', pathMatch: 'full' },
      { path: 'StackBuilder', redirectTo: 'stack-builder', pathMatch: 'full' },
      { path: 'Avaitar', redirectTo: 'aviator', pathMatch: 'full' },
      { path: 'Baccaret', redirectTo: 'baccarat', pathMatch: 'full' },
      { path: 'slot777', redirectTo: 'slot-777', pathMatch: 'full' },
      { path: 'joker777', redirectTo: 'joker-777', pathMatch: 'full' },
      { path: 'Roulette', redirectTo: 'roulette', pathMatch: 'full' },
      { path: 'Mines', redirectTo: 'mines', pathMatch: 'full' },
      { path: 'Plinko', redirectTo: 'plinko', pathMatch: 'full' },
      { path: 'Keno', redirectTo: 'keno', pathMatch: 'full' },
      { path: 'Double', redirectTo: 'double', pathMatch: 'full' },
      { path: 'Coin', redirectTo: 'toss', pathMatch: 'full' },
      { path: 'Slots', redirectTo: 'slots', pathMatch: 'full' },
      {
        path: 'ace-win',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/royalmatch/royalmatch.component').then(
            (m) => m.AppComponent,
          ),
      },

       {
        path: 'card-brag-3',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/card-brag-3/card-brag-3.component').then(
            (m) => m.AppComponent,
          ),
      },
      {
        path: 'game-account/:gameCode',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('./games/shared/game-account/game-account.component').then(
            (m) => m.GameAccountComponent,
          ),
      },
      {
        path: 'aviator',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/Avaitar/avaitar/avaitar.component').then(
            (m) => m.AvaitarComponent,
          ),
      },
      {
        path: 'lucky-trigger',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/bottle-shooter/bottle-shooter.component').then(
            (m) => m.AppComponent,
          ),
      },
      {
        path: 'baccarat',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/Baccaret/game-table/game-table.component').then(
            (m) => m.GameTableComponent,
          ),
      },
      {
        path: 'sum-dice',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/dice-roll/dice-roll.component').then(
            (m) => m.App,
          ),
      },
     {
        path: 'space-hunt',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/space-hunt/space-hunt.component').then(
            (m) => m.SpaceHuntComponent,
          ),
      },
      {
        path: 'cashbull',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/bufalo-slot/bufalo-slot.component').then(
            (m) => m.AppComponent,
          ),
      },
{
        path: 'slot-777',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/slot777/slot777.component').then(
            (m) => m.AppComponent,
          ),
      },
      {
        path: 'joker-777',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/joker777/joker777.component').then(
            (m) => m.AppComponent,
          ),
      },
      {
        path: 'chickenroad',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/chicken-road/chicken-road.component').then(
            (m) => m.ChickenRoadComponent,
          ),
      },

      {
        path: 'roulette',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/Roullet/game-layout/game-layout.component').then(
            (m) => m.GameLayoutComponent,
          ),
      },
      
      {
        path: 'mines',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/Mines/mines.component').then(
            (m) => m.MinesComponent,
          ),
      },
      {
        path: 'plinko',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/Plinko/plinko.component').then(
            (m) => m.PlinkoComponent,
          ),
      },
      {
        path: 'keno',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/keno/keno.component').then(
            (m) => m.KenoComponent,
          ),
      },
            {
        path: 'double',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('../app/games/component/double/double.component').then(
            (m) => m.DoubleComponent,
          ),
      },
      { path: 'toss', canActivate: [devToolsEntryGuard], loadComponent: () => import('../app/games/component/coin-flip/coin-flip.component').then(m => m.CoinFlipComponent) },
      { path: 'slots', canActivate: [devToolsEntryGuard], loadComponent: () => import('../app/games/component/slots/slots.component').then(m => m.SlotsComponent) },
      {
        path: 'buy-now/:cardData',
        canActivate: [devToolsEntryGuard],
        loadComponent: () =>
          import('./dashboard/Sectrech Cards/buy-now/buy-now.component').then(
            (m) => m.BuyNowComponent,
          ),
        data: { renderMode: 'client' }, // disables prerendering for this route
      },

      {
        path: 'lottery-history',
        loadComponent: () =>
          import('./pages/Lottery-Module/lottery-history/lottery-history.component').then(
            (m) => m.LotteryHistoryComponent,
          ),
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
    data: { preload: true },
  },

  {
    path: '**',
    loadComponent: () =>
      import('./wild-card-redirect/wild-card-redirect.component').then(
        (m) => m.WildCardRedirectComponent,
      ),
  },
];
